import { render, staticRenderFns } from "./ScheduleAreaHeader.vue?vue&type=template&id=31ff5237&scoped=true&"
import script from "./ScheduleAreaHeader.vue?vue&type=script&lang=ts&"
export * from "./ScheduleAreaHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleAreaHeader.vue?vue&type=style&index=0&id=31ff5237&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff5237",
  null
  
)

export default component.exports